import { useCallback } from 'react';
import { useTooltip, useTooltipInPortal, defaultStyles } from '@visx/tooltip';
import './Tooltip.css';
import Store from '../../containers/Store';
import styled from '@emotion/styled/macro';

const StyledTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const StyledCategoryAndRoleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

const StyledLabelAndMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const tooltipBgByType = {
  normal: 'var(--color-tooltip-bg)',
  warning: 'var(--color-trip-tooltip-bg)',
  critical: '#6b1e1e',
};

const tooltipTextByType = {
  warning: 'var(--color-trip-tooltip-text)',
};

const Tooltip = ({
  children,
  message,
  objectRole,
  category,
  label,
  note,
  type = 'normal',
  className,
}) => {
  const { TooltipInPortal } = useTooltipInPortal({
    detectBounds: true,
  });

  const { showTooltip, hideTooltip, tooltipOpen, tooltipData, tooltipLeft, tooltipTop } =
    useTooltip({
      tooltipOpen: false,
    });

  const tooltipStyles = {
    ...defaultStyles,
    backgroundColor: tooltipBgByType[type] || tooltipBgByType.normal,
    color: tooltipTextByType[type] || 'white',
    padding: 15,
    transition: 'opacity 0.3s ease-in-out 0s',
    zIndex: 1002,
  };

  const handlePointerMove = useCallback(
    (event) => {
      showTooltip({
        tooltipLeft: event.clientX ? event.clientX : 0,
        tooltipTop: event.clientY ? event.clientY : 0,
        tooltipData: message,
      });
    },
    [showTooltip, message]
  );

  return (
    <>
      <div
        className={`tooltip-wrapper ${className || ''}`}
        onMouseEnter={handlePointerMove}
        onMouseLeave={hideTooltip}
      >
        {children}
      </div>
      {tooltipOpen && (
        <TooltipInPortal
          key={Math.random()} // needed for bounds to update correctly
          left={tooltipLeft}
          top={tooltipTop}
          style={tooltipStyles}
        >
          <Store>
            <StyledTooltip>
              <StyledLabelAndMessageWrapper>
                <span className="text-bold">{label}</span>
                {note && <span>{note}</span>}
                {tooltipData && <span>{tooltipData}</span>}
              </StyledLabelAndMessageWrapper>
              <StyledCategoryAndRoleWrapper>
                {category && (
                  <span className="text-bold" style={{ textTransform: 'capitalize' }}>
                    {category}
                  </span>
                )}
                {objectRole && <span className="color-gray text-bold"> {objectRole}</span>}
              </StyledCategoryAndRoleWrapper>
            </StyledTooltip>
          </Store>
        </TooltipInPortal>
      )}
    </>
  );
};

export default Tooltip;
